// extracted by css-extract-rspack-plugin
var _1 = "nx";
var _2 = "ny";
export { _1 as "flyersTabBrandsItemComponent", _2 as "iconBorder" }
